import PageToolBase from './page_tool';
import { store } from '../../store';
import { TOOLS } from '../toolbar/tools';
import { windowContentScaleX, windowContentScaleY } from '../common/content_scale';

export default class TouchScale extends PageToolBase {
    /** 頁面 */
    bookPage = null;
    type = null;
    /** 是否開始移動 */
    isStartMove = false;
    /** 觸控點清單 */
    pointerList = [];
    /** 上次距離 */
    lastDistance = null;
    /** 中心點位置 */
    centerPosition = null;
    /** 縮放比例 */
    scaleRatio = 0.1

    constructor(bookPage, type) {
        super();
        this.bookPage = bookPage;
        this.type = type;
    }

    onPointerDown(e) {
    }

    onPointerMove(e) {
        if (!store.canTouchAction) return;

        // 避免存入重複的觸控點
        let index = this.pointerList.findIndex((point) => { return point.id == e.pointerId });
        if (index < 0) {
            this.pointerList.push({
                id: e.pointerId,
                x: e.x,
                y: e.y
            })
        } else {
            this.pointerList[index].x = e.x;
            this.pointerList[index].y = e.y;
        }

        // 限制雙指縮放
        if (this.pointerList.length == 2) {
            // 紀錄中心點位置
            if (this.centerPosition == null) {
                this.centerPosition = {
                    x: this.getCenter(this.pointerList[0].x, this.pointerList[1].x),
                    y: this.getCenter(this.pointerList[0].y, this.pointerList[1].y),
                }
            }

            // 計算距離並記錄
            let distance = this.getDistance(this.pointerList[0], this.pointerList[1]);
            if (this.lastDistance == null) {
                this.lastDistance = distance;
            }

            // 大於上次則放大
            if (distance > this.lastDistance) {
                this.bookPage.containerScale += this.scaleRatio;
                this.bookPage.containerScale = Math.min(this.bookPage.containerScale, 10);
            } else {
                this.bookPage.containerScale -= this.scaleRatio;
                this.bookPage.containerScale = Math.max(this.bookPage.containerScale, store.singlePageMode ? 2 : 1);
            }

            let svgContainerBoundingRect = this.bookPage.svgContainer.getBoundingClientRect();
            let pageContainerBoundingRect = this.bookPage.pageContainer.getBoundingClientRect();
            // 依照滾輪縮放公式計算
            let targetPoint = null;
            switch (this.type) {
                case 'BookPage':
                    targetPoint = {
                        x: this.centerPosition.x - svgContainerBoundingRect.x,
                        y: this.centerPosition.y - svgContainerBoundingRect.y,
                    }
                    break;
                case 'AFile':
                    targetPoint = {
                        x: this.centerPosition.x - svgContainerBoundingRect.x,
                        y: this.centerPosition.y - svgContainerBoundingRect.y,
                    }
                    break;
            }

            this.bookPage.zoom(targetPoint.x * windowContentScaleX.value, targetPoint.y * windowContentScaleY.value, this.bookPage.containerScale, this.centerPosition.x - pageContainerBoundingRect.x, this.centerPosition.y - pageContainerBoundingRect.y);
            this.lastDistance = distance;
        }
    }

    onPointerUp(e) {
        store.canTouchAction = false;

        // 清空
        this.pointerList = [];
        this.lastDistance = null;
        this.centerPosition = null;

        store.nowTool = TOOLS.SELECTION.TOOL;
    }

    /**
     * 取得中心點
     * @param {*} point1 
     * @param {*} point2 
     * @returns 
     */
    getCenter(point1, point2) {
        return Math.min(point1, point2) + Math.abs(point1 - point2) / 2;
    }

    /**
     * 計算距離
     * @param {*} point1 
     * @param {*} point2 
     */
    getDistance(point1, point2) {
        return Math.sqrt(Math.pow((point1.x - point2.x), 2) + Math.pow((point1.y - point2.y), 2));
    }
}